import type { GlobalAppCloseLocale } from "./types.js";

export function globalAppCloseAriaLabel(locale: GlobalAppCloseLocale): string {
  return locale === "en" ? "Close app" : "Закрити застосунок";
}

export function globalAppCloseConfirmCopy(locale: GlobalAppCloseLocale): {
  title: string;
  message: string;
  stay: string;
  close: string;
} {
  if (locale === "en") {
    return {
      title: "Close the app?",
      message: "Unsaved changes may be lost.",
      stay: "Stay",
      close: "Close",
    };
  }
  return {
    title: "Закрити застосунок?",
    message: "Незбережені зміни можуть бути втрачені.",
    stay: "Залишитися",
    close: "Закрити",
  };
}
